// extracted by mini-css-extract-plugin
module.exports = {"component":"CallUs_component__h3nbU","icon":"CallUs_icon__pqLyB"};